import log from "loglevel"
import { create } from "zustand"
import { API, NexusSuccessResponse } from "../api/API"
import { MissionShippingInfoWithReceiptDto, MissionShippingInfoWrapper } from "../models/missions/ShippingInfo"
import { MissionUtils } from "../utils/MissionUtils"

interface ShippingInfoStoreState {
    selectedShippingWrapperToEdit?: MissionShippingInfoWrapper
    allShippingInfoWrappers: MissionShippingInfoWrapper[]
    isFetchingShippingInfo: boolean
    shippingInfoErrorMessage?: string
}

interface ShippingInfoStoreActions {
    setSelectedShippingWrapperToEdit: (shippingInfo: MissionShippingInfoWrapper | undefined) => void
    setAllShippingInfo: (allShippingInfo: MissionShippingInfoWrapper[]) => void
    fetchShippingInfo: (missionId: string) => Promise<void>
    clearState: () => void
}

const initialShippingState: ShippingInfoStoreState = {
    allShippingInfoWrappers: [],
    isFetchingShippingInfo: false,
}

export const useShippingInfoStore = create<ShippingInfoStoreState & ShippingInfoStoreActions>((set) => ({
    ...initialShippingState,
    setSelectedShippingWrapperToEdit: (shippingInfo) => {
        set({ selectedShippingWrapperToEdit: shippingInfo })
    },
    setAllShippingInfo: (allShippingInfoWrappers) => set({ allShippingInfoWrappers }),
    fetchShippingInfo: async (missionId) => {
        set({ isFetchingShippingInfo: true })
        try {
            const result: NexusSuccessResponse<MissionShippingInfoWithReceiptDto[]> = await API.get(
                `/mission/${missionId}/shipments`,
                `Unable to fetch mission shipments with mission id ${missionId}`,
            )

            const allShippingInfoWrappers: MissionShippingInfoWrapper[] = result.data.map(
                MissionUtils.transformShippingInfoDtoToShippingInfo,
            )
            set({ allShippingInfoWrappers, isFetchingShippingInfo: false })
        } catch (e) {
            const errorMessage = e.message ?? `Error when fetching mission shipments with mission id: ${missionId}.`
            log.error(errorMessage, e)
            set({ isFetchingShippingInfo: false, shippingInfoErrorMessage: errorMessage })
        }
    },
    clearState: () => set(initialShippingState),
}))
